// Copyright (c) 2026 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { defineMessages, useIntl } from "react-intl";
import { Button, Badge } from "react-bootstrap";

import IconBadgeClose from "icons/iconBadgeClose";

interface FilterBadgeProps {
  text: string;
  type: string;
  onClear: () => void;
  onOpen?: () => void;
}

const messages = defineMessages({
  clearHint: { id: "Clear" },
});

const FilterBadge: React.FC<FilterBadgeProps> = ({ text, type, onClear, onOpen }) => {
  const intl = useIntl();
  const label = type ? `${type}: ${text}` : text;
  const clearTitle = `${intl.formatMessage(messages.clearHint)} ${label}`;

  return (
    <Badge
      key={`bt_${type || "default"}_${text || "default"}`}
      bg="secondary"
      className={`btn-badge ms-2 text-primary p-0 ps-2 pe-2 border`}
    >
      <Button
        type="button"
        className="m-0 p-0 border-0 bg-transparent text-primary"
        onClick={onClear}
        title={clearTitle}
      >
        <IconBadgeClose width={20} height={20} className="m-0 p-0 pe-2" />
      </Button>
      {onOpen ?
        <Button
          type="button"
          style={{ fontSize: "10px" }}
          className="m-0 p-0 border-0 bg-transparent text-primary text-start"
          title={text}
          onClick={onOpen}
        >
          {label}
        </Button>
      : <span
          style={{ fontSize: "10px", cursor: "default" }}
          className="m-0 p-0 border-0 bg-transparent text-primary text-start"
          title={text}
        >
          {label}
        </span>
      }
    </Badge>
  );
};

export default FilterBadge;
